import React from 'react'
import './Chatbot.css'

const Chatbot = () => {
    return (
        <div className='chatbotSectionContainer'>
            <h2 className="chatbotSectionHeader">
                Meet with Neo
            </h2>
            <p className="chatbotIntro">Our AI chatbot is just a message away, providing you with instant medical guidance right when you need it, 24/7</p>
            <div className="chatbotContainer"></div>
        </div>
    )
}

export default Chatbot